import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { PluginsResponse } from 'types/Plugins';
import {
  FilterParameters,
  generateCustomFilter,
  generateFilterExpression,
  generateIncludeQuery,
  generateSortQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

type MutationVariables = {
  queryString: string;
  tag?: string;
};

export function usePluginSearch() {
  const getPlugins = ({ queryString, tag }: MutationVariables) => {
    const filters: FilterParameters[] = [
      {
        key: 'pluginPrivacyTypeID',
        value: 1,
        type: 'equal',
      },
      {
        key: 'name',
        value: queryString,
        type: 'contains',
      },
    ];

    const queryArray = [
      generateFilterExpression('and', filters),
      generateSortQuery('modifiedAt', 'Decs'),
      generateIncludeQuery(['pluginTags']),
      ...(tag ? [generateCustomFilter('tag', tag)] : []),
    ];

    const url = generateURL(SPARK_RESOURCE_TYPES.PLUGINS, queryArray);

    return fetchWrapper<PluginsResponse>({
      url: url,
      method: 'GET',
    });
  };
  const queryResult = useMutation('plugin search', getPlugins, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to search Plugins: ${error.message}`);
      }
    },
    ...CACHE_AND_STALE_TIME,
  });

  const { data: pluginsResponse, ...restQueryResult } = queryResult;
  const { data: plugins } = pluginsResponse || {};

  return {
    plugins,
    ...restQueryResult,
  };
}
